export default {
    methods: {
        formatearTexto(text) {
            let urlRegex = /(https?:\/\/[^\s]+)/g;

            let url = text.match(urlRegex);

            let texto = text.replace(urlRegex, function (url) {
                return '<a href="' + url + '" target="_blank">' + url + "</a>";
            });
            // or alternatively
            // return text.replace(urlRegex, '<a href="$1">$1</a>')

            //console.log(texto);
            return texto;
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/FormatearTextoURL.js